module.exports = __webpack_public_path__ + "img/mt-logo-vertical.24f026ea.png";